import React from 'react';
import { BrandingWrapper, PureCarsBrand } from './styles';
export function PureCarsMeridian() {
  return /*#__PURE__*/React.createElement(BrandingWrapper, null, /*#__PURE__*/React.createElement(PureCarsBrand, null));
}
export default PureCarsMeridian;